import http from '../http'

const BASE_URL = 'ciius'

class CIIUAPI {

  async getByCompany(companyID) {
    const { data } = await http(`${BASE_URL}?company_id=${companyID}`)
    return data || []
  }
  
  async get() {
    const { data } = await http(`${BASE_URL}`)
    return data || null
  }

}

export default new CIIUAPI()